<template>
  <div>
    <zueri9-clients :absence="absence"></zueri9-clients>
    <zueri9-reason :absence="absence"></zueri9-reason>
  </div>
</template>
<script>
import Zueri9Reason from './Zueri9Reason.vue';
import Zueri9Clients from './Zueri9Clients.vue';

export default {
  name: 'Zueri9ClientAndReason',
  components: { Zueri9Clients, Zueri9Reason },
  props: {
    column:Object,
    absence:Object,
    isAssignedToDifferentView:Boolean,
  },
};
</script>
